import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { ContainersService } from "@services/containers.service";
import { Container } from "@classes/container";


@Injectable()
export class ContainersResolver  {
    constructor(
        private containersSrv: ContainersService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Container[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.containersSrv.getList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
